// extracted by mini-css-extract-plugin
export var inline = "_vq-0";